// eslint-disable-next-line import/prefer-default-export
export const toTitleCase = (str) => str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map((x) => x.charAt(0).toUpperCase() + x.slice(1)).join(' ');

export const listify = (obj, mapFn) => Object.entries(obj).reduce((acc, [key, value]) => {
  acc.push(mapFn(key, value));
  return acc;
}, []);

export const compareFields = (a, b) => {
  let retval = 0;
  if (a.order !== undefined && b.order !== undefined) {
    if (a.order < b.order) {
      retval = -1;
    }
    if (a.order > b.order) {
      retval = 1;
    }
  }

  if (a.order !== undefined && b.order === undefined) {
    retval = -1;
  }

  if (a.order === undefined && b.order !== undefined) {
    retval = 1;
  }

  if (a.order === undefined && b.order === undefined) {
    if (a.fieldName.toLowerCase() < b.fieldName.toLowerCase()) {
      retval = -1;
    }
    if (a.fieldName.toLowerCase() > b.fieldName.toLowerCase()) {
      retval = 1;
    }
  }
  return retval;
};

export const extractGroupsInOrderFromFields = (fields) => {
  const groupMap = new Map();

  fields.forEach((field) => {
    if (field.group) {
      if (!groupMap.has(field.group)) {
        groupMap.set(field.group, [field]);
      } else {
        groupMap.get(field.group).push(field);
      }
    }
  });
};

export const isEmpty = (value) => {
  let retval = false;

  if (value === null || typeof value === 'undefined') {
    retval = true;
  } else if (Array.isArray(value) || typeof value === 'string') {
    retval = value.length === 0;
  } else if (typeof value === 'object') {
    retval = !Object.keys(value).some((key) => Object.hasOwnProperty.call(value, key));
  }

  return retval;
};
